<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent(); scrollContentToTop()"
  [title]="titlePage"
  start="{{ startStage }}"
  end="{{ endStage }}"
></app-ion-common-header>

<app-loading-circle *ngIf="loading"> </app-loading-circle>

<ion-content
  *ngIf="!showRetry && !loading"
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <div
    #content
    class="content-list content-scroll"
    [ngClass]="{ 'content-list--with-button': selectedItem }"
  >
    <app-ion-common-label
      [id]="idLabelNationality"
      class="document-type-label1"
      labelStyle="display-rg"
      labelDescription="Qual é sua nacionalidade?"
    >
    </app-ion-common-label>

    <div
      class="conent-center conent-center--mrt-lg"
      [attr.aria-hidden]="ariaHidden"
    >
      <div class="my-search">
        <app-ion-common-search
          [id]="idInputSearchNationality"
          [textSearch]="textSearch"
          [ariaLabel]="'Busque por nacionalidade'"
          [placeholder]="'Busque por nacionalidade'"
          [list]="nationality"
          [fieldSearch]="fieldSearch"
          [textError]="'Nacionalidade não encontrada'"
          (sendTextSearch)="textSearch = $event"
        >
        </app-ion-common-search>
      </div>

      <app-ion-common-radio
        [id]="idRadioNationality"
        class="document-type-options"
        [itens]="nationality"
        [disabled]="!this.edit"
        [selectedValue]="selectedItem"
        [textSearch]="textSearch"
        [fieldSearch]="fieldSearch"
        (changeRadio)="selectedItem = $event; changeValue()"
        (valueNameRadio)="selectedName = $event"
      ></app-ion-common-radio>
    </div>
  </div>

  <app-ion-common-button
    [id]="idButtonNationality"
    class="hidden"
    [ngClass]="{ hidden: selectedItem?.length === 0 }"
    [attr.aria-hidden]="selectedItem?.length === 0"
    label="Continuar"
    (clickButton)="clickNext()"
  ></app-ion-common-button>
</ion-content>

<ion-content *ngIf="showRetry">
  <app-ion-common-retry
    [headerId]="headerId"
    (sendEventRetry)="getDomainNationaly()"
  >
  </app-ion-common-retry>
</ion-content>
